import { MapPin } from "lucide-react";
import { Chapter, SectionTitle, Reveal } from "./Reveal";
import { IMAGES, WINES } from "@/data/content";

const Wine = () => (
  <section id="vino" data-testid="wine-section" className="relative py-24 sm:py-36 overflow-hidden">
    <div className="max-w-7xl mx-auto px-5 sm:px-8 grid lg:grid-cols-12 gap-12 lg:gap-16 items-center">
      <div className="lg:col-span-5 order-2 lg:order-1 relative">
        <Reveal className="relative">
          <div className="overflow-hidden">
            <img
              src={IMAGES.wine}
              alt="Calice di vino rosso versato, atmosfera calda — enoteca Follonica"
              loading="lazy"
              className="w-full aspect-[3/4] object-cover hover:scale-105 transition-transform duration-[1.4s] ease-out"
            />
          </div>
          <div
            data-testid="wine-map-radius-badge"
            className="absolute -bottom-6 -right-3 sm:-right-6 bg-[#7A1C2E] text-[#F7F4EE] px-6 py-5 shadow-2xl"
          >
            <span className="flex items-center gap-2 font-cinzel text-2xl">
              <MapPin size={18} />
              ≤ 100 km
            </span>
            <span className="block mt-1 text-[10px] uppercase tracking-[0.25em] text-[#F7F4EE]/80">
              Vicini di vigna
            </span>
          </div>
        </Reveal>
      </div>

      <div className="lg:col-span-7 order-1 lg:order-2">
        <Chapter number="03" title="Il Vino" />
        <SectionTitle>
          Una carta più larga
          <span className="italic text-[#C5A059]"> del previsto.</span>
        </SectionTitle>
        <Reveal delay={0.15}>
          <p className="mt-8 text-base sm:text-lg text-[#C5BCAD] leading-relaxed max-w-xl">
            La nostra carta è più larga di quanto ci si aspetti da un posto di
            queste dimensioni. È voluto: stiamo in una terra che fa vini seri e
            vogliamo poterli versare.
          </p>
          <p className="mt-5 text-base sm:text-lg text-[#C5BCAD] leading-relaxed max-w-xl">
            Un cliente ha scritto che è "una carta da ristorante stellato". Ce la
            teniamo, come frase.
          </p>
          <p className="mt-5 text-base sm:text-lg text-[#C5BCAD] leading-relaxed max-w-xl">
            Il giovedì è la serata dei Quattro Vini: scegli quattro assaggi dalla
            carta, li accompagni con la cucina, e capisci in una sera di che
            stiamo parlando.
          </p>
        </Reveal>
        <div data-testid="wine-card-grid" className="mt-10 grid sm:grid-cols-2 gap-4 max-w-xl">
          {WINES.map((w, i) => (
            <Reveal key={w.name} delay={0.1 + i * 0.08}>
              <div className="group border border-[#F7F4EE]/10 hover:border-[#C5A059]/50 bg-[#141210] p-5 transition-colors duration-300">
                <span className="block font-display text-lg text-[#F7F4EE] group-hover:text-[#C5A059] transition-colors duration-300">
                  {w.name}
                </span>
                <span className="mt-1 block text-[11px] uppercase tracking-[0.2em] text-[#C5BCAD]/70">
                  {w.area}
                </span>
              </div>
            </Reveal>
          ))}
        </div>
      </div>
    </div>
  </section>
);

export default Wine;
